module.exports = __webpack_public_path__ + "static/media/postgrsql.db596c55.png";